import { RestSlice } from '../../redux/rest.slice';
import { CommentDto } from '@rcp/types';
import { localizationService } from 'src/services';

export const commentsSlice = new RestSlice<CommentDto>(
	localizationService.getLocalizedString('screen.labels.comment'),
	''
);
export default commentsSlice.rests.reducer;
